import React from 'react'
import { useTranslation } from 'react-i18next'
import { TAlarmReportProps } from 'src/parser/shared/PDF/Provider'

import NoContent from 'src/parser/shared/PDF/NoContent'
import { PDFError } from 'src/parser/shared/PDF/PDFError'
import Table from '../Table'
import { TSectionContent } from 'src/parser/shared/PDF/Sections'
import {
  stripBidi,
  normalizeArabicComma,
} from 'src/parser/shared/PDF/Title/CommonUtils'

import Loadable from 'src/utils/Loadable'

const Logs: TSectionContent = alarm => {
  const { logs } = alarm as TAlarmReportProps
  const { t } = useTranslation()

  if (Loadable.isFailure(logs)) return <PDFError error={logs.error} />

  if (logs.data.length === 0) return <NoContent />

  return (
    <Table
      columns={{
        date: {
          title: t('alarm_report.logs.date'),
          render: date => {
            return normalizeArabicComma(
              stripBidi(
                t('alarm_report.logs.date_format', { date: new Date(date) }),
              ),
            )
          },
          style: {
            flex: 0.2,
          },
        },
        source: {
          title: t('alarm_report.logs.source'),
          render: v => v?.userName,
          style: {
            flex: 0.15,
          },
        },
        activity: {
          title: t('alarm_report.logs.activity'),
          render: v => v,
          style: {
            flex: 0.65,
          },
        },
      }}
      rows={logs.data.map(log => ({
        date: log.date,
        source: log.author,
        activity: log.message,
      }))}
      getRowKey={log => log.date.toString()}
    />
  )
}

export default Logs
